import { combineReducers } from '@reduxjs/toolkit';

import button from './sections/button/buttonReducer.js';
import footer from './sections/footer/footerReducer.js';
import header from './sections/header/headerReducer.js';
import image from './sections/image/imageReducer.js';
import spacer from './sections/spacer/spacerReducer.js';
import text from './sections/text/textReducer.js';

export const emailsSections = combineReducers({
  text,
  header,
  button,
  spacer,
  image,
  footer,
});
